import {Opaque} from 'type-fest';

export const DISCOUNT_CODE = Symbol('Purchase discount code');
export type DiscountCode = Opaque<string, typeof DISCOUNT_CODE>;

export type VerifyPromoCodeResponse = {
  ttl: null;
};
